export const GET_ACTIVE_USER = "GET_USER";
export const SET_ACTIVE_USER = "SET_USER";
export const GET_USER_SUBSCRIPTION = "GET_USER_SUBSCRIPTION";
export const SET_USER_SUBSCRIPTION = "SET_USER_SUBSCRIPTION";
export const SET_USER_ORGANIZATIONS = "SET_USER_ORGANIZATIONS";
export const GET_USER_ORGANIZATIONS = "GET_USER_ORGANIZATIONS";
